import { Text } from '$components'
import { SendIcon } from '$components'
import { AnimatedOutlet } from '$components'

export function NoInvitationsEmptyState() {
  return (
    <div className="w-full p-12 bg-neutral-50 rounded-3xl flex flex-col items-center justify-center text-center">
      <SendIcon className="size-12 text-indigo-500 mb-4" />

      <Text
        type="h3"
        className="mb-4 text-gray-900"
      >
        No outstanding invitations
      </Text>

      <Text
        type="s"
        className="text-gray-600 max-w-sm"
      >
        When you invite team members to your organisation, they&apos;ll appear here until they accept or the invitation expires.
      </Text>

      <AnimatedOutlet />
    </div>
  )
}
